import { render, staticRenderFns } from "./Cache.vue?vue&type=template&id=35ad689e&scoped=true&"
import script from "./Cache.vue?vue&type=script&lang=js&"
export * from "./Cache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad689e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35ad689e', component.options)
    } else {
      api.reload('35ad689e', component.options)
    }
    module.hot.accept("./Cache.vue?vue&type=template&id=35ad689e&scoped=true&", function () {
      api.rerender('35ad689e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/settings/Cache.vue"
export default component.exports